module.exports = __webpack_public_path__ + "img/a.b08b0d28.png";